import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector) // Automatically detects user language
  .use(initReactI18next) // Integrates with React
  .init({
    resources: {
      en: {
        translation: require('./locales/en.json'),
      },
      ar: {
        translation: require('./locales/ar.json'),
      },
    },
    fallbackLng: 'en', // Fallback language if the user's language is unavailable
    interpolation: {
      escapeValue: false, // React already escapes output
    },
  });

export default i18n;
